/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Line from "rc-progress/es/Line";
import statusStyle from "./statusStyle";
import { Box } from "@mui/material";

type StatusProps = {
  maxPercentage: number;
  ctaButton: ReactNode;
  nextStepContent: { header: string; text: string };
};

const Status = ({ maxPercentage, ctaButton, nextStepContent }: StatusProps) => {
  const [percentActualLineProgress, setPercentActualLineProgress] = useState(0);

  useEffect(() => {
    const increasePercentage = () => {
      if (percentActualLineProgress <= maxPercentage) {
        setPercentActualLineProgress(percentActualLineProgress + 1);
        return;
      }
      clearInterval(notificationInterval);
    };
    const notificationInterval = setInterval(increasePercentage, 20);
    return () => {
      clearInterval(notificationInterval);
    };
  }, [percentActualLineProgress]);

  return (
    <Grid container>
      <Grid size={12}>
        <Box sx={statusStyle.lineProgressbarContainer}>
          <Line
            percent={percentActualLineProgress}
            strokeWidth={6}
            trailWidth={6}
            strokeColor="#137f7b"
            strokeLinecap="square"
            style={{ borderRadius: 5, marginTop: 10 }}
          />
        </Box>
      </Grid>
      <Grid size={12}>
        <Grid component={"span"} sx={statusStyle.nextStepHeading}>
          {nextStepContent.header}
        </Grid>
        <p>{nextStepContent.text}</p>
        {ctaButton}
      </Grid>
    </Grid>
  );
};

export default Status;
